import { useHistory } from 'react-router-dom';

export default useHistory;
